// This file is auto-generated by @hey-api/openapi-ts

export type AccordionElementElementModel = IApiElementModelBase & {
  properties?: AccordionElementPropertiesModel;
};

export type AccordionElementPropertiesModel = {
  title?: string | null;
  textField?: RichTextModel;
};

export type AccordionModuleElementModel = IApiElementModelBase & {
  properties?: AccordionModulePropertiesModel;
};

export type AccordionModulePropertiesModel = PaddingSizeBasePropertiesModel &
  UmbracoNavigationBasePropertiesModel &
  AnchorBasePropertiesModel & {
    preHeading?: string | null;
    headingTitle?: string | null;
    description?: string | null;
    allowOpeningMultiple?: boolean | null;
    accordionElements?: ApiBlockListModel;
  };

export type AnchorBaseElementModel = IApiElementModelBase & {
  properties?: AnchorBasePropertiesModel;
};

export type AnchorBasePropertiesModel = {
  anchor?: string | null;
  anchorDisplayName?: string | null;
};

export type ApiBlockGridAreaModel = {
  alias?: string;
  rowSpan?: number;
  columnSpan?: number;
  items?: Array<ApiBlockGridItemModel>;
};

export type ApiBlockGridItemModel = ApiBlockItemModel & {
  rowSpan?: number;
  columnSpan?: number;
  areaGridColumns?: number;
  areas?: Array<ApiBlockGridAreaModel>;
};

export type ApiBlockItemModel = {
  content?: IApiElementModel;
  settings?: IApiElementModel;
};

export type ApiBlockListModel = {
  items?: Array<ApiBlockItemModel | ApiBlockGridItemModel>;
};

export type ApiLinkModel = {
  readonly url?: string | null;
  readonly queryString?: string | null;
  readonly title?: string | null;
  readonly target?: string | null;
  readonly destinationId?: string | null;
  readonly destinationType?: string | null;
  route?: IApiContentRouteModel;
  linkType?: LinkTypeModel;
};

export type ArticleListingPageContentModel = IApiContentModelBase & {
  properties?: ArticleListingPagePropertiesModel;
};

export type ArticleListingPageContentResponseModel = IApiContentResponseModelBase & ArticleListingPageContentModel;

export type ArticleListingPagePropertiesModel = BasePagePropertiesModel;

export type ArticlePageContentModel = IApiContentModelBase & {
  properties?: ArticlePagePropertiesModel;
};

export type ArticlePageContentResponseModel = IApiContentResponseModelBase & ArticlePageContentModel;

export type ArticlePagePropertiesModel = BasePagePropertiesModel &
  PromoBasePropertiesModel & {
    category?: Array<IApiContentModel> | null;
  };

export type BasePageContentModel = IApiContentModelBase & {
  properties?: BasePagePropertiesModel;
};

export type BasePageContentResponseModel = IApiContentResponseModelBase & BasePageContentModel;

export type BasePagePropertiesModel = SEobasePropertiesModel & {
  disableBreadcrumbsOnPage?: boolean | null;
  breadcrumbsLabel?: string | null;
};

export type CategoryContentModel = IApiContentModelBase & {
  properties?: CategoryPropertiesModel;
};

export type CategoryContentResponseModel = IApiContentResponseModelBase & CategoryContentModel;

export type CategoryFolderContentModel = IApiContentModelBase & {
  properties?: CategoryFolderPropertiesModel;
};

export type CategoryFolderContentResponseModel = IApiContentResponseModelBase & CategoryFolderContentModel;

export type CategoryFolderPropertiesModel = {
  [key: string]: unknown;
};

export type CategoryPropertiesModel = {
  displayName?: string | null;
};

export type CTabreakModuleElementModel = IApiElementModelBase & {
  properties?: CTabreakModulePropertiesModel;
};

export type CTabreakModulePropertiesModel = PaddingSizeBasePropertiesModel &
  UmbracoNavigationBasePropertiesModel &
  AnchorBasePropertiesModel & {
    preHeading?: string | null;
    headingTitle?: string | null;
    primaryCTA?: Array<ApiLinkModel> | null;
    secondaryCTA?: Array<ApiLinkModel> | null;
    image?: Array<IApiMediaWithCropsModel> | null;
  };

export type GlobalSharedContentContentModel = IApiContentModelBase & {
  properties?: GlobalSharedContentPropertiesModel;
};

export type GlobalSharedContentContentResponseModel = IApiContentResponseModelBase & GlobalSharedContentContentModel;

export type GlobalSharedContentPropertiesModel = {
  [key: string]: unknown;
};

export type HeroFullBleedModuleElementModel = IApiElementModelBase & {
  properties?: HeroFullBleedModulePropertiesModel;
};

export type HeroFullBleedModulePropertiesModel = {
  preHeading?: string | null;
  headingTitle?: string | null;
  description?: RichTextModel;
  backgroundMedia?: Array<IApiMediaWithCropsModel> | null;
};

export type HomePageContentModel = IApiContentModelBase & {
  properties?: HomePagePropertiesModel;
};

export type HomePageContentResponseModel = IApiContentResponseModelBase & HomePageContentModel;

export type HomePagePropertiesModel = BasePagePropertiesModel & {
  pageHeadingModule?: ApiBlockListModel;
  pageContentModules?: ApiBlockListModel;
};

export type HttpValidationProblemDetails = ProblemDetails & {
  errors?: {
    [key: string]: Array<string>;
  };
  [key: string]: (unknown | string) | undefined;
};

export type IApiContentModel =
  | ParentCategoryContentModel
  | CategoryContentModel
  | XmlSiteMapContentModel
  | BasePageContentModel
  | GlobalSharedContentContentModel
  | RobotstxtContentModel
  | SiteSettingsLayoutContentModel
  | PromoBaseContentModel
  | CategoryFolderContentModel
  | ArticlePageContentModel
  | LandingPageContentModel
  | ArticleListingPageContentModel
  | HomePageContentModel;

export type IApiContentModelBase = IApiElementModelBase & {
  readonly id?: string;
  readonly contentType: string;
  readonly name?: string | null;
  readonly createDate?: Date;
  readonly updateDate?: Date;
  route?: IApiContentRouteModel;
};

export type IApiContentResponseModel =
  | ParentCategoryContentResponseModel
  | CategoryContentResponseModel
  | XmlSiteMapContentResponseModel
  | BasePageContentResponseModel
  | GlobalSharedContentContentResponseModel
  | RobotstxtContentResponseModel
  | SiteSettingsLayoutContentResponseModel
  | PromoBaseContentResponseModel
  | CategoryFolderContentResponseModel
  | ArticlePageContentResponseModel
  | LandingPageContentResponseModel
  | ArticleListingPageContentResponseModel
  | HomePageContentResponseModel;

export type IApiContentResponseModelBase = IApiContentModelBase & {
  readonly id?: string;
  readonly contentType: string;
  readonly name?: string | null;
  readonly createDate?: Date;
  readonly updateDate?: Date;
  route?: IApiContentRouteModel;
  readonly cultures?: {
    [key: string]: IApiContentRouteModel;
  };
};

export type IApiContentRouteModel = {
  readonly path?: string;
  startItem?: IApiContentStartItemModel;
};

export type IApiContentStartItemModel = {
  readonly id?: string;
  readonly path?: string;
};

export type IApiElementModel =
  | AccordionElementElementModel
  | PaddingSizeBaseElementModel
  | UmbracoNavigationBaseElementModel
  | HeroFullBleedModuleElementModel
  | CTabreakModuleElementModel
  | RichTextModuleElementModel
  | SEobaseElementModel
  | AccordionModuleElementModel
  | NameModuleBaseElementModel
  | AnchorBaseElementModel;

export type IApiElementModelBase = {
  readonly id?: string;
  readonly contentType: string;
};

export type IApiMediaWithCropsModel = {
  readonly id?: string;
  readonly name?: string;
  readonly mediaType?: string;
  readonly url?: string;
  readonly extension?: string | null;
  readonly width?: number | null;
  readonly height?: number | null;
  readonly bytes?: number | null;
  readonly properties?: {
    [key: string]: unknown;
  };
  focalPoint?: ImageFocalPointModel;
  readonly crops?: Array<ImageCropModel> | null;
};

export type IApiMediaWithCropsResponseModel = {
  readonly id?: string;
  readonly name?: string;
  readonly mediaType?: string;
  readonly url?: string;
  readonly extension?: string | null;
  readonly width?: number | null;
  readonly height?: number | null;
  readonly bytes?: number | null;
  readonly properties?: {
    [key: string]: unknown;
  };
  focalPoint?: ImageFocalPointModel;
  readonly crops?: Array<ImageCropModel> | null;
  readonly path?: string;
  readonly createDate?: Date;
  readonly updateDate?: Date;
};

export type ImageCropCoordinatesModel = {
  x1?: number;
  y1?: number;
  x2?: number;
  y2?: number;
};

export type ImageCropModel = {
  alias?: string | null;
  width?: number;
  height?: number;
  coordinates?: ImageCropCoordinatesModel;
};

export type ImageFocalPointModel = {
  left?: number;
  top?: number;
};

export type LandingPageContentModel = IApiContentModelBase & {
  properties?: LandingPagePropertiesModel;
};

export type LandingPageContentResponseModel = IApiContentResponseModelBase & LandingPageContentModel;

export type LandingPagePropertiesModel = PromoBasePropertiesModel &
  BasePagePropertiesModel & {
    pageHeadingModule?: ApiBlockListModel;
    pageContentModules?: ApiBlockListModel;
  };

export type LinkTypeModel = 'Content' | 'Media' | 'External';

export const LinkTypeModel = {
  CONTENT: 'Content',
  MEDIA: 'Media',
  EXTERNAL: 'External',
} as const;

export type NameModuleBaseElementModel = IApiElementModelBase & {
  properties?: NameModuleBasePropertiesModel;
};

export type NameModuleBasePropertiesModel = {
  cMSLabel?: string | null;
};

export type PaddingSizeBaseElementModel = IApiElementModelBase & {
  properties?: PaddingSizeBasePropertiesModel;
};

export type PaddingSizeBasePropertiesModel = {
  paddingTop?: string | null;
  paddingBottom?: string | null;
};

export type PagedIApiContentResponseModel = {
  total: number;
  items: Array<IApiContentResponseModel>;
};

export type PagedIApiMediaWithCropsResponseModel = {
  total: number;
  items: Array<IApiMediaWithCropsResponseModel>;
};

export type ParentCategoryContentModel = IApiContentModelBase & {
  properties?: ParentCategoryPropertiesModel;
};

export type ParentCategoryContentResponseModel = IApiContentResponseModelBase & ParentCategoryContentModel;

export type ParentCategoryPropertiesModel = {
  [key: string]: unknown;
};

export type ProblemDetails = {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: (unknown | string | number) | undefined;
};

export type PromoBaseContentModel = IApiContentModelBase & {
  properties?: PromoBasePropertiesModel;
};

export type PromoBaseContentResponseModel = IApiContentResponseModelBase & PromoBaseContentModel;

export type PromoBasePropertiesModel = {
  promoTitle?: string | null;
  promoImage?: Array<IApiMediaWithCropsModel> | null;
  promoDescription?: string | null;
};

export type RichTextModel = {
  markup: string;
  blocks: Array<ApiBlockItemModel | ApiBlockGridItemModel>;
};

export type RichTextModuleElementModel = IApiElementModelBase & {
  properties?: RichTextModulePropertiesModel;
};

export type RichTextModulePropertiesModel = AnchorBasePropertiesModel &
  UmbracoNavigationBasePropertiesModel &
  PaddingSizeBasePropertiesModel & {
    preHeading?: string | null;
    headingTitle?: string | null;
    content?: RichTextModel;
    primaryCTA?: Array<ApiLinkModel> | null;
    secondaryCTA?: Array<ApiLinkModel> | null;
  };

export type RobotstxtContentModel = IApiContentModelBase & {
  properties?: RobotstxtPropertiesModel;
};

export type RobotstxtContentResponseModel = IApiContentResponseModelBase & RobotstxtContentModel;

export type RobotstxtPropertiesModel = {
  disallowAll?: boolean | null;
  disallowedURLs?: Array<string> | null;
  disallowedSearchEngines?: Array<string> | null;
  crawlDelayForSearch?: ApiBlockListModel;
  sitemapURLs?: Array<string> | null;
  imageSitemapURLs?: Array<string> | null;
};

export type SEobaseElementModel = IApiElementModelBase & {
  properties?: SEobasePropertiesModel;
};

export type SEobasePropertiesModel = {
  pageTitle?: string | null;
  metaDescription?: string | null;
  openGraphTitle?: string | null;
  openGraphDescription?: string | null;
  openGraphImage?: Array<IApiMediaWithCropsModel> | null;
  hideFromSearch?: boolean | null;
  structuredDataThirdPartyTags?: string | null;
  searchEngineChangeFrequency?: string | null;
  hideFromXmlSitemap?: boolean | null;
  searchEngineRelativePriority?: number | null;
};

export type SiteSettingsLayoutContentModel = IApiContentModelBase & {
  properties?: SiteSettingsLayoutPropertiesModel;
};

export type SiteSettingsLayoutContentResponseModel = IApiContentResponseModelBase & SiteSettingsLayoutContentModel;

export type SiteSettingsLayoutPropertiesModel = {
  socialLinks?: ApiBlockListModel;
  defaultOpenGraphImage?: Array<IApiMediaWithCropsModel> | null;
  siteLogo?: Array<IApiMediaWithCropsModel> | null;
  cookieNoticeMessage?: RichTextModel;
  headSectionScripts?: string | null;
  bodySectionScripts?: string | null;
  enableBreadcrumbs?: boolean | null;
  breadcrumbsShouldContainHome?: boolean | null;
  favicon?: Array<IApiMediaWithCropsModel> | null;
};

export type UmbracoNavigationBaseElementModel = IApiElementModelBase & {
  properties?: UmbracoNavigationBasePropertiesModel;
};

export type UmbracoNavigationBasePropertiesModel = {
  umbracoNaviHide?: boolean | null;
};

export type XmlSiteMapContentModel = IApiContentModelBase & {
  properties?: XmlSiteMapPropertiesModel;
};

export type XmlSiteMapContentResponseModel = IApiContentResponseModelBase & XmlSiteMapContentModel;

export type XmlSiteMapPropertiesModel = {
  excludedDocumentTypes?: string | null;
  isImageSiteMap?: boolean | null;
};

export type GetContentData = {
  headers?: {
    /**
     * Defines the language to return. Use this when querying language variant content items.
     */
    'Accept-Language'?: string;
    /**
     * API key specified through configuration to authorize access to the API.
     */
    'Api-Key'?: string;
    /**
     * Whether to request draft content.
     */
    Preview?: boolean;
    /**
     * URL segment or GUID of a root content item.
     */
    'Start-Item'?: string;
  };
  query?: {
    /**
     * Defines the properties that should be expanded in the response. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api#query-parameters) for more details on this.
     */
    expand?: string;
    /**
     * Specifies the content items to fetch. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api#query-parameters) for more details on this.
     */
    fetch?: string;
    /**
     * Defines how to filter the fetched content items. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api#query-parameters) for more details on this.
     */
    filter?: Array<string>;
    /**
     * Specifies the number of found content items to skip. Use this to control pagination of the response.
     */
    skip?: number;
    /**
     * Defines how to sort the found content items. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api#query-parameters) for more details on this.
     */
    sort?: Array<string>;
    /**
     * Specifies the number of found content items to take. Use this to control pagination of the response.
     */
    take?: number;
  };
};

export type GetContentResponse = PagedIApiContentResponseModel;

export type GetContentError = ProblemDetails | HttpValidationProblemDetails;

export type GetContent20Data = {
  headers?: {
    /**
     * Defines the language to return. Use this when querying language variant content items.
     */
    'Accept-Language'?: string;
    /**
     * API key specified through configuration to authorize access to the API.
     */
    'Api-Key'?: string;
    /**
     * Whether to request draft content.
     */
    Preview?: boolean;
    /**
     * URL segment or GUID of a root content item.
     */
    'Start-Item'?: string;
  };
  query?: {
    /**
     * Defines the properties that should be expanded in the response. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api#query-parameters) for more details on this.
     */
    expand?: string;
    /**
     * Specifies the content items to fetch. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api#query-parameters) for more details on this.
     */
    fetch?: string;
    /**
     * Explicitly defines which properties should be included in the response (by default all properties are included). Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api#query-parameters) for more details on this.
     */
    fields?: string;
    /**
     * Defines how to filter the fetched content items. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api#query-parameters) for more details on this.
     */
    filter?: Array<string>;
    /**
     * Specifies the number of found content items to skip. Use this to control pagination of the response.
     */
    skip?: number;
    /**
     * Defines how to sort the found content items. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api#query-parameters) for more details on this.
     */
    sort?: Array<string>;
    /**
     * Specifies the number of found content items to take. Use this to control pagination of the response.
     */
    take?: number;
  };
};

export type GetContent20Response = PagedIApiContentResponseModel;

export type GetContent20Error = ProblemDetails | HttpValidationProblemDetails;

export type GetContentItemData = {
  headers?: {
    /**
     * Defines the language to return. Use this when querying language variant content items.
     */
    'Accept-Language'?: string;
    /**
     * API key specified through configuration to authorize access to the API.
     */
    'Api-Key'?: string;
    /**
     * Whether to request draft content.
     */
    Preview?: boolean;
    /**
     * URL segment or GUID of a root content item.
     */
    'Start-Item'?: string;
  };
  query?: {
    /**
     * Defines the properties that should be expanded in the response. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api#query-parameters) for more details on this.
     */
    expand?: string;
    id?: Array<string>;
  };
};

export type GetContentItemResponse = Array<IApiContentResponseModel>;

export type GetContentItemError = ProblemDetails | HttpValidationProblemDetails;

export type GetContentItemByPathData = {
  headers?: {
    /**
     * Defines the language to return. Use this when querying language variant content items.
     */
    'Accept-Language'?: string;
    /**
     * API key specified through configuration to authorize access to the API.
     */
    'Api-Key'?: string;
    /**
     * Whether to request draft content.
     */
    Preview?: boolean;
    /**
     * URL segment or GUID of a root content item.
     */
    'Start-Item'?: string;
  };
  path: {
    path: string;
  };
  query?: {
    /**
     * Defines the properties that should be expanded in the response. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api#query-parameters) for more details on this.
     */
    expand?: string;
  };
};

export type GetContentItemByPathResponse = IApiContentResponseModel;

export type GetContentItemByPathError = ProblemDetails | HttpValidationProblemDetails;

export type GetContentItemByPath20Data = {
  headers?: {
    /**
     * Defines the language to return. Use this when querying language variant content items.
     */
    'Accept-Language'?: string;
    /**
     * API key specified through configuration to authorize access to the API.
     */
    'Api-Key'?: string;
    /**
     * Whether to request draft content.
     */
    Preview?: boolean;
    /**
     * URL segment or GUID of a root content item.
     */
    'Start-Item'?: string;
  };
  path: {
    path: string;
  };
  query?: {
    /**
     * Defines the properties that should be expanded in the response. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api#query-parameters) for more details on this.
     */
    expand?: string;
    /**
     * Explicitly defines which properties should be included in the response (by default all properties are included). Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api#query-parameters) for more details on this.
     */
    fields?: string;
  };
};

export type GetContentItemByPath20Response = IApiContentResponseModel;

export type GetContentItemByPath20Error = ProblemDetails | HttpValidationProblemDetails;

export type GetContentItemByIdData = {
  headers?: {
    /**
     * Defines the language to return. Use this when querying language variant content items.
     */
    'Accept-Language'?: string;
    /**
     * API key specified through configuration to authorize access to the API.
     */
    'Api-Key'?: string;
    /**
     * Whether to request draft content.
     */
    Preview?: boolean;
    /**
     * URL segment or GUID of a root content item.
     */
    'Start-Item'?: string;
  };
  path: {
    id: string;
  };
  query?: {
    /**
     * Defines the properties that should be expanded in the response. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api#query-parameters) for more details on this.
     */
    expand?: string;
  };
};

export type GetContentItemByIdResponse = IApiContentResponseModel;

export type GetContentItemByIdError = ProblemDetails | HttpValidationProblemDetails;

export type GetContentItemById20Data = {
  headers?: {
    /**
     * Defines the language to return. Use this when querying language variant content items.
     */
    'Accept-Language'?: string;
    /**
     * API key specified through configuration to authorize access to the API.
     */
    'Api-Key'?: string;
    /**
     * Whether to request draft content.
     */
    Preview?: boolean;
    /**
     * URL segment or GUID of a root content item.
     */
    'Start-Item'?: string;
  };
  path: {
    id: string;
  };
  query?: {
    /**
     * Defines the properties that should be expanded in the response. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api#query-parameters) for more details on this.
     */
    expand?: string;
    /**
     * Explicitly defines which properties should be included in the response (by default all properties are included). Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api#query-parameters) for more details on this.
     */
    fields?: string;
  };
};

export type GetContentItemById20Response = IApiContentResponseModel;

export type GetContentItemById20Error = ProblemDetails | HttpValidationProblemDetails;

export type GetContentItems20Data = {
  headers?: {
    /**
     * Defines the language to return. Use this when querying language variant content items.
     */
    'Accept-Language'?: string;
    /**
     * API key specified through configuration to authorize access to the API.
     */
    'Api-Key'?: string;
    /**
     * Whether to request draft content.
     */
    Preview?: boolean;
    /**
     * URL segment or GUID of a root content item.
     */
    'Start-Item'?: string;
  };
  query?: {
    /**
     * Defines the properties that should be expanded in the response. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api#query-parameters) for more details on this.
     */
    expand?: string;
    /**
     * Explicitly defines which properties should be included in the response (by default all properties are included). Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api#query-parameters) for more details on this.
     */
    fields?: string;
    id?: Array<string>;
  };
};

export type GetContentItems20Response = Array<IApiContentResponseModel>;

export type GetContentItems20Error = ProblemDetails | HttpValidationProblemDetails;

export type GetMediaData = {
  headers?: {
    /**
     * API key specified through configuration to authorize access to the API.
     */
    'Api-Key'?: string;
  };
  query?: {
    /**
     * Defines the properties that should be expanded in the response. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api/media-delivery-api#query-parameters) for more details on this.
     */
    expand?: string;
    /**
     * Specifies the media items to fetch. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api/media-delivery-api#query-parameters) for more details on this.
     */
    fetch?: string;
    /**
     * Defines how to filter the fetched media items. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api/media-delivery-api#query-parameters) for more details on this.
     */
    filter?: Array<string>;
    /**
     * Specifies the number of found media items to skip. Use this to control pagination of the response.
     */
    skip?: number;
    /**
     * Defines how to sort the found media items. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api/media-delivery-api#query-parameters) for more details on this.
     */
    sort?: Array<string>;
    /**
     * Specifies the number of found media items to take. Use this to control pagination of the response.
     */
    take?: number;
  };
};

export type GetMediaResponse = PagedIApiMediaWithCropsResponseModel;

export type GetMediaError = ProblemDetails | HttpValidationProblemDetails;

export type GetMedia20Data = {
  headers?: {
    /**
     * API key specified through configuration to authorize access to the API.
     */
    'Api-Key'?: string;
  };
  query?: {
    /**
     * Defines the properties that should be expanded in the response. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api/media-delivery-api#query-parameters) for more details on this.
     */
    expand?: string;
    /**
     * Specifies the media items to fetch. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api/media-delivery-api#query-parameters) for more details on this.
     */
    fetch?: string;
    /**
     * Explicitly defines which properties should be included in the response (by default all properties are included). Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api/media-delivery-api#query-parameters) for more details on this.
     */
    fields?: string;
    /**
     * Defines how to filter the fetched media items. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api/media-delivery-api#query-parameters) for more details on this.
     */
    filter?: Array<string>;
    /**
     * Specifies the number of found media items to skip. Use this to control pagination of the response.
     */
    skip?: number;
    /**
     * Defines how to sort the found media items. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api/media-delivery-api#query-parameters) for more details on this.
     */
    sort?: Array<string>;
    /**
     * Specifies the number of found media items to take. Use this to control pagination of the response.
     */
    take?: number;
  };
};

export type GetMedia20Response = PagedIApiMediaWithCropsResponseModel;

export type GetMedia20Error = ProblemDetails | HttpValidationProblemDetails;

export type GetMediaItemData = {
  headers?: {
    /**
     * API key specified through configuration to authorize access to the API.
     */
    'Api-Key'?: string;
  };
  query?: {
    /**
     * Defines the properties that should be expanded in the response. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api/media-delivery-api#query-parameters) for more details on this.
     */
    expand?: string;
    id?: Array<string>;
  };
};

export type GetMediaItemResponse = Array<IApiMediaWithCropsResponseModel>;

export type GetMediaItemError = unknown;

export type GetMediaItemByPathData = {
  headers?: {
    /**
     * API key specified through configuration to authorize access to the API.
     */
    'Api-Key'?: string;
  };
  path: {
    path: string;
  };
  query?: {
    /**
     * Defines the properties that should be expanded in the response. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api/media-delivery-api#query-parameters) for more details on this.
     */
    expand?: string;
  };
};

export type GetMediaItemByPathResponse = IApiMediaWithCropsResponseModel;

export type GetMediaItemByPathError = ProblemDetails | HttpValidationProblemDetails;

export type GetMediaItemByPath20Data = {
  headers?: {
    /**
     * API key specified through configuration to authorize access to the API.
     */
    'Api-Key'?: string;
  };
  path: {
    path: string;
  };
  query?: {
    /**
     * Defines the properties that should be expanded in the response. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api/media-delivery-api#query-parameters) for more details on this.
     */
    expand?: string;
    /**
     * Explicitly defines which properties should be included in the response (by default all properties are included). Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api/media-delivery-api#query-parameters) for more details on this.
     */
    fields?: string;
  };
};

export type GetMediaItemByPath20Response = IApiMediaWithCropsResponseModel;

export type GetMediaItemByPath20Error = ProblemDetails | HttpValidationProblemDetails;

export type GetMediaItemByIdData = {
  headers?: {
    /**
     * API key specified through configuration to authorize access to the API.
     */
    'Api-Key'?: string;
  };
  path: {
    id: string;
  };
  query?: {
    /**
     * Defines the properties that should be expanded in the response. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api/media-delivery-api#query-parameters) for more details on this.
     */
    expand?: string;
  };
};

export type GetMediaItemByIdResponse = IApiMediaWithCropsResponseModel;

export type GetMediaItemByIdError = ProblemDetails | HttpValidationProblemDetails;

export type GetMediaItemById20Data = {
  headers?: {
    /**
     * API key specified through configuration to authorize access to the API.
     */
    'Api-Key'?: string;
  };
  path: {
    id: string;
  };
  query?: {
    /**
     * Defines the properties that should be expanded in the response. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api/media-delivery-api#query-parameters) for more details on this.
     */
    expand?: string;
    /**
     * Explicitly defines which properties should be included in the response (by default all properties are included). Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api/media-delivery-api#query-parameters) for more details on this.
     */
    fields?: string;
  };
};

export type GetMediaItemById20Response = IApiMediaWithCropsResponseModel;

export type GetMediaItemById20Error = ProblemDetails | HttpValidationProblemDetails;

export type GetMediaItems20Data = {
  headers?: {
    /**
     * API key specified through configuration to authorize access to the API.
     */
    'Api-Key'?: string;
  };
  query?: {
    /**
     * Defines the properties that should be expanded in the response. Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api/media-delivery-api#query-parameters) for more details on this.
     */
    expand?: string;
    /**
     * Explicitly defines which properties should be included in the response (by default all properties are included). Refer to [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api/media-delivery-api#query-parameters) for more details on this.
     */
    fields?: string;
    id?: Array<string>;
  };
};

export type GetMediaItems20Response = Array<IApiMediaWithCropsResponseModel>;

export type GetMediaItems20Error = unknown;

export type GetMediaResponseTransformer = (data: any) => Promise<GetMediaResponse>;

export type PagedIApiMediaWithCropsResponseModelModelResponseTransformer = (
  data: any,
) => PagedIApiMediaWithCropsResponseModel;

export type IApiMediaWithCropsResponseModelModelResponseTransformer = (data: any) => IApiMediaWithCropsResponseModel;

export const IApiMediaWithCropsResponseModelModelResponseTransformer: IApiMediaWithCropsResponseModelModelResponseTransformer =
  (data) => {
    if (data?.createDate) {
      data.createDate = new Date(data.createDate);
    }
    if (data?.updateDate) {
      data.updateDate = new Date(data.updateDate);
    }
    return data;
  };

export const PagedIApiMediaWithCropsResponseModelModelResponseTransformer: PagedIApiMediaWithCropsResponseModelModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.items)) {
      data.items.forEach(IApiMediaWithCropsResponseModelModelResponseTransformer);
    }
    return data;
  };

export const GetMediaResponseTransformer: GetMediaResponseTransformer = async (data) => {
  PagedIApiMediaWithCropsResponseModelModelResponseTransformer(data);
  return data;
};

export type GetMedia20ResponseTransformer = (data: any) => Promise<GetMedia20Response>;

export const GetMedia20ResponseTransformer: GetMedia20ResponseTransformer = async (data) => {
  PagedIApiMediaWithCropsResponseModelModelResponseTransformer(data);
  return data;
};

export type GetMediaItemResponseTransformer = (data: any) => Promise<GetMediaItemResponse>;

export const GetMediaItemResponseTransformer: GetMediaItemResponseTransformer = async (data) => {
  if (Array.isArray(data)) {
    data.forEach(IApiMediaWithCropsResponseModelModelResponseTransformer);
  }
  return data;
};

export type GetMediaItemByPathResponseTransformer = (data: any) => Promise<GetMediaItemByPathResponse>;

export const GetMediaItemByPathResponseTransformer: GetMediaItemByPathResponseTransformer = async (data) => {
  IApiMediaWithCropsResponseModelModelResponseTransformer(data);
  return data;
};

export type GetMediaItemByPath20ResponseTransformer = (data: any) => Promise<GetMediaItemByPath20Response>;

export const GetMediaItemByPath20ResponseTransformer: GetMediaItemByPath20ResponseTransformer = async (data) => {
  IApiMediaWithCropsResponseModelModelResponseTransformer(data);
  return data;
};

export type GetMediaItemByIdResponseTransformer = (data: any) => Promise<GetMediaItemByIdResponse>;

export const GetMediaItemByIdResponseTransformer: GetMediaItemByIdResponseTransformer = async (data) => {
  IApiMediaWithCropsResponseModelModelResponseTransformer(data);
  return data;
};

export type GetMediaItemById20ResponseTransformer = (data: any) => Promise<GetMediaItemById20Response>;

export const GetMediaItemById20ResponseTransformer: GetMediaItemById20ResponseTransformer = async (data) => {
  IApiMediaWithCropsResponseModelModelResponseTransformer(data);
  return data;
};

export type GetMediaItems20ResponseTransformer = (data: any) => Promise<GetMediaItems20Response>;

export const GetMediaItems20ResponseTransformer: GetMediaItems20ResponseTransformer = async (data) => {
  if (Array.isArray(data)) {
    data.forEach(IApiMediaWithCropsResponseModelModelResponseTransformer);
  }
  return data;
};
